// Activity Connection - Calendar Builder
// Author: Allen Peloquin (PNDLM)
//
// actions.js - Redux actions for app state transitions
//

import {fetchJson} from '../lib/ACHelpers'
import axios from 'axios'
import React from "react";
import {EVERYTIME, PESTER, STICKY, SESSION_TIMEOUT} from "./constant";
import { createRevision, isEditingCalendar, updateIsNotEditing } from './EditorActions';

// UI Actions

// Network Actions
export const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE"
export const REQUEST_DOCUMENTS = "REQUEST_DOCUMENTS"
export const RECEIVE_DOCUMENTS = "RECEIVE_DOCUMENTS"
export const RECEIVE_DOCUMENT = "RECEIVE_DOCUMENT"
export const REQUEST_DELETE_DOCUMENT = "REQUEST_DELETE_DOCUMENT"
export const DELETED_DOCUMENT = "DELETED_DOCUMENT"
export const REQUEST_SET_DOCUMENT_PUBLIC = "REQUEST_SET_DOCUMENT_PUBLIC"
export const REQUEST_SET_DOCUMENT_TO_PUBLIC = "REQUEST_SET_DOCUMENT_TO_TEMPLATE"
export const ERROR_DOCUMENTS = "ERROR_DOCUMENTS"

export const ORDER_BEGIN = "ORDER_BEGIN"
export const ORDER_DOCUMENT = "ORDER_DOCUMENT"
export const ORDER_COMPLETE = "ORDER_COMPLETE"
export const ORDER_ERROR = "ORDER_ERROR"
export const ORDER_CANCEL = "ORDER_CANCEL"

export const RENAME_BEGIN = "RENAME_BEGIN"
export const RENAME_DOCUMENT = "RENAME_DOCUMENT"
export const RENAME_COMPLETE = "RENAME_COMPLETE"
export const RENAME_ERROR = "RENAME_ERROR"
export const RENAME_CANCEL = "RENAME_CANCEL"
export const REQUEST_SET_DOCUMENT_NAME = "REQUEST_SET_DOCUMENT_NAME"
export const BACKGROUND_COLOR_DEFAULT = '#1A5CC7';
export const TEXT_COLOR_DEFAULT = '#FFFFFF';
// action creators

// I think I see a super general pattern here we could probably generalize
export function setDocumentType(documentType = 'calendar') {
	return { type: SET_DOCUMENT_TYPE, documentType }
}

function requestDocuments() {
	return { type: REQUEST_DOCUMENTS }
}

function receiveDocuments(json) {
	return { type: RECEIVE_DOCUMENTS, json, receivedAt: Date.now() }
}

function receiveDocument(gridDocument) {
	return { type: RECEIVE_DOCUMENT, gridDocument, receivedAt: Date.now() }
}

function requestDeleteDocument(documentId) {
	return { type: REQUEST_DELETE_DOCUMENT, documentId }
}

function deletedDocument(documentId) {
	return { type: DELETED_DOCUMENT, documentId }
}

function requestSetDocumentPublic(documentId, isPublic) {
	return { type: REQUEST_SET_DOCUMENT_PUBLIC, documentId, isPublic }
}

function requestSetDocumentToTemplate(documentId, isTemplate) {
	return { type: REQUEST_SET_DOCUMENT_TO_PUBLIC, documentId, isTemplate }
}

function requestSetDocumentName(documentId, name) {
	return { type: REQUEST_SET_DOCUMENT_NAME, documentId, name }
}

function fetchDocuments(documentType = undefined, searchTextField = null, sortBy = null, year = undefined, month = undefined, limit, isBranded = false) {
  return async dispatch => {
    if (limit <= 30) {
      dispatch(requestDocuments())
    }
    let endpoint = "/gridDocuments"
    let parameters = ""
    let typeId = null
    let typeIsTemplate = null
    let deleted = 0

    if (documentType) {
      if (documentType === 'deletedCalendars') {
        typeId = 0
        typeIsTemplate = 0
        deleted = 1
      } else {
        typeId = documentType.includes("calendar") ? 0 : 1
        typeIsTemplate = documentType.includes("template") ? 1 : 0
      }
    }

    parameters = parameters + "deleted=" + deleted

    if (typeId != null) {
      parameters = parameters + "&typeId=" + typeId
    }
    if (typeIsTemplate != null) {
      parameters = parameters + (parameters ? "&" : "") + "typeIsTemplate=" + typeIsTemplate
    }
    if (searchTextField) {
      parameters = parameters + (parameters ? "&" : "") + "search=" + searchTextField
    }
    if (sortBy) {
      parameters = parameters + (parameters ? "&" : "") + "sortBy=" + sortBy
    }
    if (year) {
      parameters = parameters + (parameters ? "&" : "") + "year=" + year
    }
    if (month) {
      parameters = parameters + (parameters ? "&" : "") + "month=" + month
    }
    if (limit) {
      parameters = parameters + (parameters ? "&" : "") + "limit=" + limit
    }

    isBranded = isBranded ? isBranded : ''
    parameters = parameters + (parameters ? "&isBranded=" + isBranded : "isBranded=" + isBranded);

    if (parameters) {
      endpoint = endpoint + "?" + parameters
    }
    return await fetchJson(endpoint)
      .then(json => {
        dispatch(receiveDocuments(json.result.gridDocuments))
      })
  }
}

function shouldFetchDocuments(state) {
	return !state.isLoadingDocuments
}

function shouldDeleteDocument(state) {
  if (!state.documentType || state.documentType === 'calendar') {
    return true;
  }
	return !state.isLoading && window.confirm("Are you sure you want to permanently delete this document?")
}

function shouldSetDocumentPublic(state) {
	return !state.isLoading
}

function shouldSetDocumentName(state, name = '') {
	return !state.isLoading && name > ''
}

// ORDER FORM / NETWORK CALLS

export function beginDocumentOrder(documentId) {
	return { type: ORDER_BEGIN, documentId: documentId }
}

export function closeDocumentOrder() {
	return { type: ORDER_CANCEL }
}

export async function reGenerateToken () {
	await updateIsNotEditing();
	window.reloadPage()
}

export async function getInAppMessage(userId) {
	await axios.get('/inAppMessage/toast')
		.then(function (response) {
		if (response.data.inAppMessage && response.data.isToast && response.data.inAppMessage.is_active == 1) {
			const toastToken = JSON.parse(sessionStorage.getItem('toastToken'));
			if ((!toastToken && response.data.inAppMessage.persistence_type === EVERYTIME) ||  (toastToken && (toastToken.token !== response.data.inAppMessage.token || toastToken.userId !== userId))) {
				document.getElementById("toast-message").innerHTML = response.data.inAppMessage.message;
				const toast = document.getElementById("snackbar");
				toast.className = "show";
				if (response.data.inAppMessage.message_type === PESTER) {
					document.getElementById("close-toast").style.display = 'none';
				} else {
                    document.getElementById("close-toast").style.display = '';

                }

				if (response.data.inAppMessage.bg_color) {
					toast.style.backgroundColor = response.data.inAppMessage.bg_color || BACKGROUND_COLOR_DEFAULT;
				}

				if (response.data.inAppMessage.text_color) {
					toast.style.color = response.data.inAppMessage.text_color || TEXT_COLOR_DEFAULT;
				}


				if (response.data.inAppMessage.message_type === STICKY) {
					toast.className.replace("show", "");
				} else {
					const duration = response.data.inAppMessage.display_duration ? response.data.inAppMessage.display_duration * 1000 : 5000;
					setTimeout(function () {
						toast.className = toast.className.replace("show", "");
						}, duration);
				}
			}

			sessionStorage.setItem('toastToken', JSON.stringify({
				token: response.data.inAppMessage.token,
				userId:userId
			}));
		}
		})
		.catch(function (error) {
			console.log(error);
		});
}

export async function createToken() {
	let uid = 1;
	if (sessionStorage.getItem('uid')) {
		uid = sessionStorage.getItem('uid');
	}
	return await axios.get('/auth/generateToken?uid=' + uid)
		.then(function (response) {
			if(response.status === 200) {
				return response.data.authToken;
			}
		})
		.catch(function (error) {
			console.log(error);
		});
}

export async function getNewTokenFromServer(userId) {
	return await fetchJson('/auth/users/' + userId)
		.then(json => {
			if(json.status === 200) {
				return json.result.user.authToken;
			}
		})
}

export async function resetTimer() {
	let resetTimerUrl = "/users/resetTimeout";
	let expiredText = "Session expired. Please return to ActivityConnection website.";

	return await fetchJson(resetTimerUrl)
		.then((response) => {
			if(response.status === 200) {
				sessionStorage.setItem('start_time', JSON.stringify(Date.now()));
				sessionStorage.setItem('isLossConnect', 'false');

				if (sessionStorage.getItem('isShowingPopupDisconnected') === 'true') {
					document.getElementById("popup-disconnected").style.display = "none";
					sessionStorage.setItem('isShowingPopupDisconnected', 'false');
				}
			}

			if (response.data === expiredText) {
				document.getElementById("popup-missing-cookie").style.display = "block";
			}
		});
}

export async function countDownSessionTimeout(state = null) {
	let startTime = Date.now();
	if (sessionStorage.getItem('start_time')) {
		startTime = JSON.parse(sessionStorage.getItem('start_time'));
	}

	if (startTime + SESSION_TIMEOUT * 60 * 1000 <= Date.now() + 60 * 1000) {
		sessionStorage.setItem('ignoreToShowUnsavedChanges', 'true');

		document.getElementById("popup-expired").style.display = "block";
		let remainTimeAvailable = Math.floor(((startTime + SESSION_TIMEOUT * 60 * 1000) - Date.now()) / 1000);
		if (remainTimeAvailable >= 0) {
			if (state && sessionStorage.getItem('hasDataChanged') && isEditingCalendar(state)) {
				state.dispatch(createRevision(state.doc.gridDocumentId, 'Auto-Saved', false));
			}

			document.getElementById("message-expired").innerHTML = "Calendar Builder will close in " + "<span style='font-weight: bold'>" + remainTimeAvailable + "</span>" + " seconds. ";
			document.getElementById('continue-session').addEventListener('click', () => reGenerateToken())
		} else {
			await createToken();
			window.location = '/expired';
		}
	}
}

export async function checkUrlExpired (isCreateFromParent = false) {
	if (location.search) {
    	let checkTokenUrl = '/auth/checkToken' + location.search;
    	if (isCreateFromParent) {
			checkTokenUrl += '&isCreated=true';
		}

		await axios.get( checkTokenUrl)
			.then(function (response) {
				if(response && response.data && response.data.isExpired === 1) {
					window.location = '/expired';
				}
				if (isCreateFromParent && !sessionStorage.getItem('count_reload')) {
					sessionStorage.setItem('count_reload', JSON.stringify(1));
					window.location.reload();
				}
			})
			.catch(function (error) {
				console.log(error);
			});
    }
}

export function requestOrderPrints(documentId, currentUser, PSP_URL, pageFormat, pageOrientation) {
	return dispatch => {
		// Get user From PSP
		return fetchJson('/pps/requestOrderPrints/' + documentId,'post')
		.then(json => {
			if(json.success === true && json.documentId && json.productId && json.token) {
				return openOrderPSP(json.documentId, json.productId, PSP_URL, json.token, json.authToken, json.ownerId, json.fileName, pageFormat, pageOrientation)
			}
			alert("Sorry we don't support printing for this document template at this time.")
		})
	}
}

function openOrderPSP(documentId, productId, PSP_URL, token, authToken, ownerId, fileName, pageFormat, pageOrientation) {
	let endpoint = PSP_URL + '/#/print-order/new';
	let fileDocumentName = fileName.replace(/[^a-zA-Z0-9-_ ]/g, "");

	let parameters = "sharetoken=" + token
	parameters += "&authToken=" + authToken
	parameters += "&ownerId=" + ownerId
	parameters += "&docid=" + documentId
	parameters += "&filename=" + fileDocumentName
	parameters += "&filetype=pdf"
	parameters += "&productid=" + productId
	parameters += "&pageFormat=" + pageFormat
	parameters += "&pageOrientation=" + pageOrientation
    parameters += "&timestamp" + (new Date()).getTime();

	if (parameters) {
		endpoint = endpoint + "?" + parameters
	}
	window.open(endpoint,'_blank').focus()
}

// RENAME FORM / NETWORK CALLS

export function beginDocumentRename(documentId) {
	return { type: RENAME_BEGIN, documentId: documentId }
}

export function closeDocumentRename() {
	return { type: RENAME_CANCEL }
}

export function setDocumentName(documentId, name, props) {
	name = name.trim();
	return (dispatch, getState) => {
		if (shouldSetDocumentPublic(getState(), name)) {
			dispatch(requestSetDocumentName(documentId, name))
			let endpoint = "/gridDocuments/" + documentId
			return fetchJson(endpoint, 'post', JSON.stringify({name}))
			.then(json => {
				if (json.result) {
                    if (json.result.invalid) {
                        alert(json.result.invalid);
                    } else {
                        dispatch(receiveDocument(json.result.gridDocument))
                        dispatch(closeDocumentRename())
                        props.callFetchDocument()
                    }
				} else {
					alert("An error occurred.")
				}

			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export function onDivClick (){
	if ( typeof(Storage) !== 'undefined') {
		sessionStorage.setItem('IsNotShowWarningDialogIE', 'true');
	}
    document.getElementById('browserAlert').className = 'hide';
    sessionStorage.setItem('warn_div', '1')
}

export function showWarningDialogIE() {
    if (!detectIEBrowser2()) {
        return ""
    }
	if ( typeof(Storage) !== 'undefined') {
		if (!sessionStorage.getItem('IsNotShowWarningDialogIE')) {
			return <div id="browserAlert" className="alert" style={{textAlign: 'center'}}>
				<span className="closebtn"
					  onClick={onDivClick} >&times;</span>
				 <img src="/img/alert-circled.svg" height="15px"></img>
				<strong>WARNING: Internet Explorer is currently incompatible with Calendar Builder and Print Services Portal.</strong>  Please use a modern web browser like Chrome, Firefox, or Edge.
			</div>
		}
		return '';
	}

	return <div id="browserAlert" className="alert">
				<span className="closebtn"
                      onClick={onDivClick} >&times;</span>
         <img src="/img/alert-circled.svg" height="15px"></img>
        <strong>WARNING: Internet Explorer is old version.</strong>  Please update your Internet Explorer.
    </div>
}
export function detectIEBrowser2() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersionRecommended = '';
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

    // In Opera 15+, the true version is after "OPR/"
    if ((verOffset=nAgt.indexOf("OPR/"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
    }
    // In older Opera, the true version is after "Opera" or after "Version"
    else if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+6);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
        majorVersionRecommended = "62";
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset+8);
        majorVersionRecommended = "62";
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
        (verOffset=nAgt.lastIndexOf('/')) )
    {
        browserName = nAgt.substring(nameOffset,verOffset);
        fullVersion = nAgt.substring(verOffset+1);
        if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
        fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
        fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
        fullVersion  = ''+parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion,10);
    }

    if (browserName == "Microsoft Internet Explorer" || ("Netscape" == browserName)) {
        return true;
    }
    return false;
}

export function fetchDocumentsIfNeeded(documentType = undefined , searchTextField = null, sortBy = null, year = undefined, month = undefined, limit, isBranded = false) {
	return (dispatch, getState) => {
		if (shouldFetchDocuments(getState())) {
			return dispatch(fetchDocuments(documentType, searchTextField , sortBy, year, month, limit, isBranded))
		}
		else {
			return Promise.resolve()
		}
	}
}

export function deleteDocument(documentId, content, documentType) {
	return (dispatch, getState) => {
		if (shouldDeleteDocument(getState())) {
			dispatch(requestDeleteDocument(documentId))
			let endpoint = "/gridDocuments/" + documentId;
			const size = content.length;
			let isReload = true;
			let document = content.find((element) => {
				return element.props.doc.gridDocumentId === documentId;
			});

			for (let i = 0; i < size; i++) {

				if ((content[i].props.doc.year === document.props.doc.year)
					&& (content[i].props.doc.month === document.props.doc.month)
					&& (content[i].props.doc.gridDocumentId !== document.props.doc.gridDocumentId)) {
					isReload = false;
				}
			}

			return fetchJson(endpoint, 'delete')
			.then(json => {
				if (!json.error) {
					dispatch(deletedDocument(documentId));
					if (isReload) {
						clearSelectedFilterDateValue(documentType);
						window.location.reload(true)
					}
				} else {
					window.location.reload(true)
				}
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export function setDocumentPublic(documentId, isPublic) {
	return (dispatch, getState) => {
		if (shouldSetDocumentPublic(getState())) {
			dispatch(requestSetDocumentPublic(documentId, isPublic))
			let endpoint = "/gridDocuments/" + documentId
			return fetchJson(endpoint, 'post', JSON.stringify({isPublic}))
			.then(json => {
				dispatch(receiveDocument(json.result.gridDocument))
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export function setDocumentToTemplate(documentId, isTemplate, documentType, content, categoryName) {
	return (dispatch, getState) => {
		if (shouldSetDocumentPublic(getState())) {
			dispatch(requestSetDocumentToTemplate(documentId, isTemplate))
			let endpoint = "/gridDocuments/" + documentId;
			return fetchJson(endpoint, 'post', JSON.stringify({isTemplate, categoryName}))
			.then(json => {
				if (documentType) {
					dispatch(deletedDocument(documentId))
                    if (content.length - 1 === 0) {
                        window.location.reload(true)
                    }
				} else {
					dispatch(receiveDocument(json.result.gridDocument))
				}
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

function clearSelectedFilterDateValue(documentType) {
  let key = 'documentList_selectedFilterDateValue';
  if (documentType) {
    key = key + '_' + documentType;
  }
  sessionStorage.removeItem(key);
  sessionStorage.removeItem('documentList_filterDateValue');
}



// WEBPACK FOOTER //
// ./src/data/DocumentListActions.js